export const CHANGE_NAVIGATION_THEME = 'CHANGE_NAVIGATION_THEME';
export const RECEIVE_COMPANIES = 'RECEIVE_COMPANIES';
export const FETCH_COMPANY = 'FETCH_COMPANY';

export const RECEIVE_PERSONS = 'RECEIVE_PERSONS';
export const CLEAR_PERSONS = 'CLEAR_PERSONS';
export const FETCH_CURRENT_PERSON = 'FETCH_CURRENT_PERSON';
export const FETCH_PERSON = 'FETCH_PERSON';
export const SET_CATEGORY = 'SET_CATEGORY';
export const BUSY_PERSON = 'BUSY_PERSON';

export const RECEIVE_NAVIGATION = 'RECEIVE_NAVIGATION';
export const RECEIVE_GLOBAL = 'RECEIVE_GLOBAL';
export const RECEIVE_PAGE = 'RECEIVE_PAGE';
export const CHANGE_THEME = 'CHANGE_THEME';

export const VOTE_COUNTER = 'VOTE_COUNTER';
export const VOTE_BUSY = 'VOTE_BUSY';

export const RECEIVE_REFS = 'RECEIVE_REFS';
export const RECEIVE_REF = 'RECEIVE_REF';
export const UPDATE_REF = 'UPDATE_REF';
export const FETCH_REF = 'FETCH_REF';
export const CLEAR_REF = 'CLEAR_REF';
export const TEMP_REF = 'TEMP_REF';

export const IMAGE_UPLOADED = 'IMAGE_UPLOADED';

export const INCREASE_COUNTER = 'INCREASE_COUNTER';
export const VOTE_SLIDE = 'VOTE_SLIDE';

export const UPDATE_FANCY_COUNTER = 'UPDATE_FANCY_COUNTER';
export const RECEIVE_FANCY_LIST = 'RECEIVE_FANCY_LIST';
export const DELETED_FANCY_DONE = 'DELETED_FANCY_DONE';
export const DELETED_FANCY_LIST = 'DELETED_FANCY_LIST';
export const UPDATE_FANCY_LIST = 'UPDATE_FANCY_LIST';
export const FANCY_LIST_OFFSET = 'FANCY_LIST_OFFSET';
export const TAG_FANCY_UPDATE = 'TAG_FANCY_UPDATE';
export const CLEAR_FANCY_LIST = 'CLEAR_FANCY_LIST';
export const FANCY_LIST_BUSY = 'FANCY_LIST_BUSY';
export const APPROVED_FANCY = 'APPROVED_FANCY';

export const CHANGE_BLUR = 'CHANGE_BLUR';

export const RECEIVE_ADMIN_LIST = 'RECEIVE_ADMIN_LIST';
export const UPDATE_ADMIN_LIST = 'UPDATE_ADMIN_LIST';
export const ADMIN_LIST_OFFSET = 'ADMIN_LIST_OFFSET';
export const ADMIN_LIST_BUSY = 'ADMIN_LIST_BUSY';
export const CLEAR_ADMIN_LIST = 'CLEAR_ADMIN_LIST';
export const TAG_ADMIN_UPDATE = 'TAG_ADMIN_UPDATE';
export const UPDATE_ADMIN_LIST_VOTE = 'UPDATE_ADMIN_LIST_VOTE';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js